import { type AuthUser } from "wasp/auth";
import Breadcrumb from "../../layout/Breadcrumb";
import DefaultLayout from "../../layout/DefaultLayout";
import { useRedirectHomeUnlessUserIsAdmin } from "../../useRedirectHomeUnlessUserIsAdmin";
import FeedsTable from "./FeedsTable";

const FeedsDashboard = ({ user }: { user: AuthUser }) => {
  useRedirectHomeUnlessUserIsAdmin({ user });

  return (
    <DefaultLayout user={user}>
      <Breadcrumb pageName="RSS Feeds Management" />
      <div className="flex flex-col gap-10">
        <FeedsTable />
      </div>
    </DefaultLayout>
  );
};

export default FeedsDashboard;
